import React from "react";

export default function Getjob({ jobsList, jobIndex }) {
  if (!jobsList || jobsList.length === 0) {
    return "מחלקה לא מוגדרת";
  }
  const searchType = jobsList.find((job) => job.id == jobIndex);
  return searchType ? searchType.title : "תפקיד לא מוגדר";
}
